import { getAccessToken, getDeviceId } from 'helpers/tokenManager';

export const getUploadHeaders = {
  headers: {
    'content-type': 'multipart/form-data',
    'Authorization': `Bearer ${getAccessToken()}`,
    'deviceId': getDeviceId(),
    'X-Accept-ProblemDetails': true
  }
};
